import React from 'react';
import { useTranslation } from 'react-i18next';

const CareerDriverDescription = () => {
	const { t } = useTranslation();

	return (
		<div className="driver-desc">
			<h1 className="title semibold">{t('careers.driverDesc.title')}</h1>
			<p className="content">{t('careers.driverDesc.content')}</p>
		</div>
	);
};

export default CareerDriverDescription;
